import Vuex from 'vuex';
import Vue from 'vue';
import axios from 'axios';
import groupBy from 'lodash/groupBy';

import modules from './modules';

const {
  eventsModule,
  invitesModule,
  usersModule,
  integrationsModule,
  webhooksModule,
} = modules;

function loadAxiosDefaults() {
  axios.defaults.baseURL = 'https://habitica-monster-api.herokuapp.com'; // 'http://localhost:8082';

  const storedUser = localStorage.getItem('habitica-token-user');
  if (storedUser) {
    try {
      const userJson = JSON.parse(storedUser);
      if (userJson) {
        axios.defaults.headers.common.Authorization = `Bearer ${userJson.token}`;
      }
    } catch (e) {
      console.log(e);
    }
  }
}

let viewedActivityDates = {};
function loadActivitySeen() {
  const storeActivitySeen = localStorage.getItem('spritely-viewedActivityDates');
  if (!storeActivitySeen) return;
  try {
    const activityJson = JSON.parse(storeActivitySeen);
    if (!activityJson) return;
    viewedActivityDates = activityJson;
  } catch (e) {
    console.log(e);
  }
}

let viewedAchievements = {};
function loadViewedAchievements() {
  const storedViewedAchievements = localStorage.getItem('spritely-viewedAchievements');
  if (!storedViewedAchievements) return;
  try {
    const parsed = JSON.parse(storedViewedAchievements);
    if (!parsed) return;
    viewedAchievements = parsed;
  } catch (e) {
    console.log(e);
  }
}

loadAxiosDefaults();
loadActivitySeen();
loadViewedAchievements();

function getStore() {
  const store = new Vuex.Store({
    state: {
      user: {},
      events: [],
      eventId: 1,
      metaMaskStatus: false,
      favoriteMonster: {},
      usersMonsters: [],
      viewedActivityDates,
      viewedAchievements,
      integrations: {},
      displayAdventureGuide: false,
      loading: true,
    },
    mutations: {
      addEvent(state, payload) {
        payload.eventDetails.id = state.eventId + 1;
        this.eventId = payload.eventDetails.id;
        state.events.push(payload.eventDetails);
      },
      favoriteMonster(state, payload) {
        state.favoriteMonster = state.favoriteMonster === payload.monster ? {} : payload.monster;
      },
      setLastViewActivityForId(state, payload) {
        const { id } = payload;
        Vue.set(state.viewedActivityDates, id, new Date());
        localStorage.setItem('spritely-viewedActivityDates', JSON.stringify(state.viewedActivityDates));
      },
      setAchievement(state, payload) {
        const { achievement } = payload;
        Vue.set(state.viewedAchievements, achievement, true);
        localStorage.setItem('spritely-viewedAchievements', JSON.stringify(state.viewedAchievements));
      },
      setIntegrations(state, payload) {
        const integrationProviders = groupBy(payload.integrations, 'provider');
        Vue.set(state, 'integrations', integrationProviders);
      },
    },
    modules: {
      eventsModule,
      invitesModule,
      usersModule,
      integrationsModule,
      webhooksModule,
    },
  });

  return store;
}

export default getStore;



// WEBPACK FOOTER //
// ./src/store/index.js